// Import React hooks
import { useRef, useState } from "react";



// Export the reusable How It Works state hook
export const useHowItWorks = (defaultJourney = "store") => {

    // Store which How It Works journey is currently being displayed
    const [activeJourney, setActiveJourney] = useState(defaultJourney);

    // Store a reference to the How It Works section
    const howItWorksRef = useRef(null);



    // Change the journey without scrolling
    const selectJourney = (journeyKey) => {

        // Update the currently selected journey
        setActiveJourney(journeyKey);

    };



    // Change the journey and scroll the user to the section
    const showJourney = (journeyKey) => {

        // Update the currently selected journey
        setActiveJourney(journeyKey);

        // Wait until the browser has had a chance to update the component
        window.requestAnimationFrame(() => {

            // Scroll the How It Works section into view
            howItWorksRef.current?.scrollIntoView({

                // Scroll smoothly rather than jumping
                behavior: "smooth",

                // Position the section near the top of the viewport
                block: "start",

            });

        });

    };



    // Return everything required by the page and component
    return {

        // Return the selected journey
        activeJourney,

        // Return the section reference
        howItWorksRef,

        // Return the non-scrolling selector
        selectJourney,

        // Return the scrolling selector
        showJourney,

    };

};